"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassiveAggressiveTimer = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var ReactHelpers_1 = require("./ReactHelpers");
/**
 * A component used to trigger a handler when time-interval has elapsed.
 * The time-interval is reset if:
 *  • the document loses focus
 *  • the element recieves mouse-interactivity
 */
var PassiveAggressiveTimer = /** @class */ (function (_super) {
    tslib_1.__extends(PassiveAggressiveTimer, _super);
    function PassiveAggressiveTimer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.timerId = null;
        _this.boundStopTimer = null;
        _this.boundStartTimer = null;
        _this.handleMouseOver = ReactHelpers_1.mergeEventHandlers(function (e) {
            _this.stopTimer();
        }, function (e) { var _a, _b, _c; return (_c = (_a = _this.props.children) === null || _a === void 0 ? void 0 : (_b = _a.props).onMouseOver) === null || _c === void 0 ? void 0 : _c.call(_b, e); });
        _this.handleMouseOut = ReactHelpers_1.mergeEventHandlers(function (e) {
            _this.startTimer();
        }, function (e) { var _a, _b, _c; return (_c = (_a = _this.props.children) === null || _a === void 0 ? void 0 : (_b = _a.props).onMouseOut) === null || _c === void 0 ? void 0 : _c.call(_b, e); });
        _this.handleTouchStart = ReactHelpers_1.mergeEventHandlers(function (e) {
            _this.stopTimer();
        }, function (e) { var _a, _b, _c; return (_c = (_a = _this.props.children) === null || _a === void 0 ? void 0 : (_b = _a.props).onTouchStart) === null || _c === void 0 ? void 0 : _c.call(_b, e); });
        _this.handleTouchEnd = ReactHelpers_1.mergeEventHandlers(function (e) {
            _this.startTimer();
        }, function (e) { var _a, _b, _c; return (_c = (_a = _this.props.children) === null || _a === void 0 ? void 0 : (_b = _a.props).onTouchEnd) === null || _c === void 0 ? void 0 : _c.call(_b, e); });
        _this.stopTimer = function () {
            if (_this.timerId) {
                window.clearTimeout(_this.timerId);
            }
        };
        _this.startTimer = function () {
            _this.stopTimer();
            if (_this.props.handleTimerElapsed) {
                _this.timerId = window.setTimeout(_this.props.handleTimerElapsed, _this.props.timerDuration);
            }
        };
        return _this;
    }
    PassiveAggressiveTimer.prototype.componentDidMount = function () {
        this.boundStartTimer = this.startTimer.bind(this);
        this.boundStopTimer = this.stopTimer.bind(this);
        window.addEventListener('blur', this.boundStopTimer);
        window.addEventListener('focus', this.boundStartTimer);
        this.startTimer();
    };
    PassiveAggressiveTimer.prototype.componentWillUnmount = function () {
        window.removeEventListener('blur', this.boundStopTimer);
        window.removeEventListener('focus', this.boundStartTimer);
        this.stopTimer();
    };
    PassiveAggressiveTimer.prototype.render = function () {
        var child = React.Children.only(this.props.children);
        return React.cloneElement(child, {
            onMouseOut: this.handleMouseOut,
            onMouseOver: this.handleMouseOver,
            onTouchEnd: this.handleTouchEnd,
            onTouchStart: this.handleTouchStart,
        });
    };
    return PassiveAggressiveTimer;
}(React.Component));
exports.PassiveAggressiveTimer = PassiveAggressiveTimer;
//# sourceMappingURL=PassiveAggressiveTimer.js.map